import React from 'react';
import classNames from 'classnames';
import { getAccessLevelIcon } from '../../../../utils';
import { DataRoomNodeAccessLevel, DataRoomNodeAccessState } from 'models/Lead';
import { Loader } from 'ncoded-component-library';

import './DisplayFilesByFileTrigger.styles.scss';

type DisplayFilesByFileTriggerProps = {
  className?: string;
  name: string;
  accessLevel: DataRoomNodeAccessLevel;
  state: DataRoomNodeAccessState;
  isLoading?: boolean;
  onClick?: () => void;
};

const DisplayFilesByFileTrigger: React.FC<DisplayFilesByFileTriggerProps> = (
  props,
) => {
  const { className, accessLevel, name, state, isLoading, onClick } = props;

  const classes = classNames('display-files-by-file-trigger', state, className);

  const AccessLevelIcon = getAccessLevelIcon({ accessLevel });

  return (
    <div
      className={classes}
      onClick={(e) => {
        e.stopPropagation();

        onClick?.();
      }}
    >
      <AccessLevelIcon />
      <span className="display-files-by-file-trigger__name">{name}</span>
      {isLoading && <Loader size="small" />}
    </div>
  );
};

export default DisplayFilesByFileTrigger;
